export enum FileTypes {
  Excel = 'Excel',
  Delimited = 'Delimited',
  Image = 'Image',
  All = 'ALL'
}
